import { render, staticRenderFns } from "./SurveysViewController.vue?vue&type=template&id=4bd94a04"
import script from "./SurveysViewController.vue?vue&type=script&lang=js"
export * from "./SurveysViewController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd94a04')) {
      api.createRecord('4bd94a04', component.options)
    } else {
      api.reload('4bd94a04', component.options)
    }
    module.hot.accept("./SurveysViewController.vue?vue&type=template&id=4bd94a04", function () {
      api.rerender('4bd94a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/List/SurveysViewController.vue"
export default component.exports